module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-16.10bbd78e.png";